import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import BattleResult from './components/BattleResult';
import Header from './components/Header';
import Footer from './components/Footer';
import TrendingPage from './pages/TrendingPage';
import HistoryPage from './pages/HistoryPage';
import AccountPage from './pages/AccountPage';
import PricingPage from './pages/PricingPage';
import RulesPage from './pages/RulesPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { ErrorBoundary } from './errors/ErrorBoundary';
import { NotFoundPage } from './errors/NotFoundPage';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <div className="main">
            <Header />
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<App />} />
                <Route path="/battle/:id" element={<BattleResult />} />
                <Route path="/trending" element={<TrendingPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/rules" element={<RulesPage />} />
                <Route path="/code-of-conduct" element={<Navigate to="/rules" replace />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/result" element={<Navigate to="/" replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </ErrorBoundary>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
